import { trackCoreJourneyEvent } from './coreJourneyAnalytics';
import { textLengthBucket } from './planningUpdatesAnalytics';

export type HomepageSearchPlacement = 'search_input' | 'quick_search';

export function trackHomepageSearchSubmission(
  query: string,
  placement: HomepageSearchPlacement,
): void {
  const cleaned = query.trim();
  if (!cleaned) return;

  const tokenLengthBucket = textLengthBucket(cleaned);
  const metadata = {
    page_type: 'homepage',
    search_origin: 'homepage',
    token_length_bucket: tokenLengthBucket,
  };

  trackCoreJourneyEvent('planning_research', 'search_submitted', {
    source: 'homepage',
    placement,
    entityType: 'search',
    status: tokenLengthBucket,
    metadata,
  });
  trackCoreJourneyEvent('planning_research', 'planning_updates_search_term_submitted', {
    source: 'homepage',
    placement,
    entityType: 'search_token',
    entityId: cleaned,
    status: tokenLengthBucket,
    metadata,
  });
}
